import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SpreadsheetComponent } from "./s25.spreadsheet.component";
import { FileUploadModule } from "../s25-file-upload/s25.file.upload.module";
import { S25ButtonComponent } from "../../standalone/s25.button.component";

@NgModule({
    declarations: [SpreadsheetComponent],
    imports: [CommonModule, FormsModule, FileUploadModule, S25ButtonComponent],
    providers: [SpreadsheetComponent],
    exports: [SpreadsheetComponent],
})
export class SpreadsheetModule {
    constructor() {}
}
